<template>
    <div>
        <Header />
        <PageTitle />
        <BlogDetailsContent />
        <Footer />
    </div>
</template>

<script>
import Header from '../Layout/Header'
import PageTitle from '../BlogDetails/PageTitle'
import BlogDetailsContent from '../BlogDetails/BlogDetailsContent'
import Footer from '../Layout/Footer'

export default {
    name: 'BlogDetailsPage',
    components: {
        Header,
        PageTitle,
        BlogDetailsContent,
        Footer,
    }
}
</script>